export const handleSize = 8;
export const regionStyleCreation = {
  background: 'rgba(255, 107, 0, 0.25)',
  border: '1px dashed rgba(255, 107, 0, 1)',
};
export const regionStyleSelected = {
  background: 'rgba(255, 107, 0, 0.25)',
  border: '1px dashed rgba(255, 107, 0, 1)',
  zIndex: 900,
};
export const regionStyleNotSelected = {
  background: 'rgba(240, 240, 0, 0.5)',
  border: '1px dashed rgba(240, 240, 0, 1)',
  // zIndex: 0
};
export const style = {
  Region: {
    position: 'absolute',
    border: '3px black', // dashed rgba(0,0,0,0.5)',
    //outline: '1px dashed rgba(255,255,255,0.5)',
    cursor: 'move',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'end',
  },
  RegionHandleSE: {
    position: 'absolute',
    opacity: '0.0',
    bottom: (-1 * handleSize) / 2,
    right: (-1 * handleSize) / 2,
    width: handleSize,
    height: handleSize,
    outline: '1px solid rgba(0,0,0,0.5)',
    border: '1px solid rgba(255,255,255,0.5)',
    cursor: 'se-resize',
  },
  RegionHandleSW: {
    position: 'absolute',
    opacity: '0.0',
    bottom: (-1 * handleSize) / 2,
    left: (-1 * handleSize) / 2,
    width: handleSize,
    height: handleSize,
    outline: '1px solid rgba(0,0,0,0.5)',
    border: '1px solid rgba(255,255,255,0.5)',
    cursor: 'sw-resize',
  },
  LockIcon: {
    position: 'absolute',
    botton: -5,
    color: 'green',
    left: '43%',
    cursor: 'pointer',
  },
  UnLockIcon: {
    position: 'absolute',
    botton: -2 * handleSize,
    color: '#ff0000',
    left: '43%',
    cursor: 'pointer',
  },
  RegionHandleNW: {
    position: 'absolute',
    opacity: '0.0',
    top: (-1 * handleSize) / 2,
    left: (-1 * handleSize) / 2,
    width: handleSize,
    height: handleSize,
    outline: '1px solid rgba(0,0,0,0.5)',
    border: '1px solid rgba(255,255,255,0.5)',
    cursor: 'nw-resize',
  },
  RegionHandleNE: {
    position: 'absolute',
    opacity: '0.0',
    top: (-1 * handleSize) / 2,
    right: (-1 * handleSize) / 2,
    width: handleSize,
    height: handleSize,
    outline: '1px solid rgba(0,0,0,0.5)',
    border: '1px solid rgba(255,255,255,0.5)',
    cursor: 'ne-resize',
  },
  RegionSelect: {
    position: 'relative',
    display: 'inline-block',
  },
};
export const successStyle = {
  // minWidth: '200px',
  padding: '5px',
  margin: '5px',
  width: '95%',
  minHeight: '45px',
  color: 'black',
  backgroundColor: 'rgb(241, 241, 241)',
};
export const concreteStyle = {
  // minWidth: '200px',
  padding: '5px',
  margin: '5px',
  width: '28%',
  minHeight: '45px',
  color: 'black',
  backgroundColor: 'rgb(241, 241, 241)',
};
export const dayStyle = {
  // minWidth: '200px',
  padding: '2px',
  margin: '2px',
  width: '10%',
  minHeight: '11px',
  color: 'black',
  backgroundColor: 'rgb(241, 241, 241)',
};
export const errorStyle = {
  // minWidth: '200px',
  padding: '5px',
  margin: '5px',
  minHeight: '45px',
  width: '95%',
  color: 'black',
  backgroundColor: 'rgb(241, 241, 241)',
  outline: '1px solid #ff0000',
};
export const concreteErrorStyle = {
  // minWidth: '200px',
  padding: '5px',
  margin: '5px',
  minHeight: '45px',
  width: '28%',
  color: 'black',
  backgroundColor: 'rgb(241, 241, 241)',
  outline: '1px solid #ff0000',
};
export const concreteErrorStyleDay = {
  // minWidth: '200px',
  padding: '2px',
  margin: '2px',
  width: '10%',
  minHeight: '11px',
  color: 'black',
  backgroundColor: 'rgb(241, 241, 241)',
  outline: '1px solid #ff0000',
};
